import React from 'react';
import { ArrowRight, Truck, Settings, BarChart, Check } from 'lucide-react';
import { useLanguage } from '../lib/LanguageContext';
export function SolutionOverview() {
  const {
    t
  } = useLanguage();
  return <section id="solutions" className="py-16 md:py-24 lg:py-40 bg-forest-50 relative overflow-hidden" data-id="element-305">
      <div className="container mx-auto px-4 sm:px-6 md:px-8 relative z-10" data-id="element-306">
        <div className="max-w-3xl mb-10 md:mb-16 lg:mb-24" data-id="element-307">
          <p className="text-forest-500 font-semibold text-xs uppercase tracking-[0.2em] mb-6" data-id="element-308">
            {t.solutions.label}
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-forest-900 tracking-tight leading-tight" data-id="element-309">
            {t.solutions.headline}
          </h2>
          <p className="text-forest-600 text-xl font-light mt-6 max-w-2xl" data-id="element-310">
            {t.solutions.subtitle}
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-311">
          {t.solutions.items.map((solution, index) => <div key={index} className="group bg-white rounded-2xl p-8 shadow-sm border border-forest-100 hover:shadow-md hover:border-forest-200 transition-all relative overflow-hidden" data-id="element-312">
              <div className="text-6xl font-bold text-forest-100 mb-6 font-mono select-none group-hover:text-forest-200 transition-colors" data-id="element-313">
                {solution.id}
              </div>
              <h3 className="text-xl font-bold text-forest-900 mb-4 group-hover:text-brand-green transition-colors" data-id="element-314">
                {solution.title}
              </h3>
              <p className="text-forest-600 text-base leading-relaxed mb-8 min-h-[80px]" data-id="element-315">
                {solution.description}
              </p>
              <ul className="space-y-3" data-id="element-316">
                {solution.features.map((feature, idx) => <li key={idx} className="flex items-center text-sm text-forest-700" data-id="element-317">
                    <span className="w-1.5 h-1.5 rounded-full bg-brand-green mr-3 flex-shrink-0" data-id="element-318" />
                    {feature}
                  </li>)}
              </ul>
            </div>)}
        </div>
      </div>
    </section>;
}